import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";
import VueGoogleMaps from "@fawmi/vue-google-maps";

loadFonts();

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "ap-south-1_v1ZJAUw7z",
      userPoolClientId: "59eliorb3ktd0vchl2690cbfb2",
      identityPoolId: "ap-south-1:e9263e3d-77aa-4fda-9254-184e09e9a8b0",
      signUpVerificationMethod: "code",
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    GraphQL: {
      endpoint:
        "https://o2jdvn7rfngitagfcmswmsqg7q.appsync-api.ap-south-1.amazonaws.com/graphql",
      region: "ap-south-1",
      defaultAuthMode: "userPool",
      logger_level: "DEBUG",
    },
  },
  Storage: {
    S3: {
      bucket: "dyrectori-mobile",
      region: "ap-south-1",
      logger_level: "DEBUG",
    },
  },
});

const app = createApp(App);

app
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyDhmoCen3u5B9_ikCRHJRKwu3sJkritFdQ",
      libraries: "places",
    },
  })
  .mount("#app");
